var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeTestingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tree-testing-a",
    x1: "2.247%",
    x2: "123.428%",
    y1: "0%",
    y2: "121.641%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2673FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#96FF51"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(18.5 13.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tree-testing-a)",
    d: "M22,44.5 C26.8347005,44.5 43.5,40.5389267 43.5,26.641427 C43.5,22.2424007 39.7930478,18.1607635 38.098125,14.5628754 C34.4384107,6.7942368 30.9169966,0.5 22.8014337,0.5 C16.1896057,0.5 18.0888477,5.87355275 12.6945313,8.45282679 C4.52872482,12.3572794 0.5,17.2041209 0.5,26.641427 C0.5,40.5389267 17.1652995,44.5 22,44.5 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 25,
    r: 2.5,
    fill: "#FFBB48"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 11,
    r: 2.5,
    fill: "#FFBB48"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 26.5,
    r: 4,
    fill: "#FFBB48"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 32 21.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#2673FF",
    points: "20.613 -5.908 20.613 20.128 7.351 16.867",
    transform: "rotate(90 13.982 7.11)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF6969",
    fillOpacity: 0.8,
    points: "20.848 15.333 3.733 22.366 .568 15.333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeTestingIcon);
export default __webpack_public_path__ + "static/media/tree-testing-icon.2573c94da2a7c94b40b10600ec6f97e3.svg";
export { ForwardRef as ReactComponent };